import classNames from "classnames";
import { ESIInclude } from "../__shared__/ESIInclude/ESIInclude";
import styles from "./WishList.module.scss";
import { FeatureFlags } from "@/types/types";

type Props = {
  /**
   * A string representing the SKU ID of the product.
   */
  skuId: string;
  /**
   * A boolean indicating whether the SKU is selected.
   */
  isSkuSelected: boolean;
  /**
   * A string representing the product ID from the Product Information Management system.
   */
  pimProductId: string;
  /**
   * A boolean indicating whether the product is available to order.
   */
  isAvailableToOrder: boolean;
  /**
   * A string representing the source for the ESI.
   */
  esiSrc: string;
  flags: FeatureFlags;
};

export const WishListUI = ({
  skuId,
  isSkuSelected,
  pimProductId,
  isAvailableToOrder,
  esiSrc,
  flags,
}: Props) => {
  const showWishlistIconButtonVariant =
    flags.showWishlistIconButtonVariant.value;

  if (
    showWishlistIconButtonVariant === "a" ||
    showWishlistIconButtonVariant === "b"
  ) {
    return null;
  }

  return (
    <div
      className={classNames(
        styles["container"],
        styles.wishlist,
        "esi-wrapper",
      )}
      data-testid="wish-list-esi"
      id="add-to-wish-list-esi"
      data-sku={skuId}
      data-sku-selected={isSkuSelected}
      data-product-details={JSON.stringify({
        productId: pimProductId,
        isOutOfStock: !isAvailableToOrder,
      })}
      data-component="WishList"
    >
      <ESIInclude src={esiSrc} id="add-to-wishlist-component" />
    </div>
  );
};
